module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-product-hair-2-en.4afb61c9.png";